import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderNextWeek: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalenderNextWeek"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM19 9H5V19H19V9ZM9 11.0858L11.9142 14L9 16.9142L7.58579 15.5L9.08579 14L7.58579 12.5L9 11.0858ZM13.75 11.0858L16.6642 14L13.75 16.9142L12.3358 15.5L13.8358 14L12.3358 12.5L13.75 11.0858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderNextWeek;
